import React, { useState, useContext, useEffect, useRef } from "react";
import "../../styles/offsetting.css";
import loader2 from "../../images/loader_2.gif";
import ApiService from "../../api/apiService";
import showSwal from "../swal";
import { common } from "../../util/common";
import { convertTo12HourPlusDateFormat } from "../../util/helperFunctions";
import "../../styles/ccar-form.css";

console.log("=== CCAR FORM VERSION 2 ===");
function CcarForm(props) {
  console.log("CCAR PROPS:", props);

  const { formDetails, setReferenceId, setDateAndTime, setFormSubmitted } =
    props;
  const loaderRef = useRef(null);

  const [isSubmitting, setSubmitting] = useState(false);

  const [attachments, setAttachments] = useState([]);
  const [formData, setFormData] = useState({
    issuedTo: "",
    ncSource: "",
    warehouse: "",
    referenceNumber: "",
    ncDescription: "",
  });

  const { issuedTo, ncSource, warehouse, referenceNumber, ncDescription } =
    formData;

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    setAttachments((prev) => [...prev, ...selectedFiles]);

    // Allow selecting the same file again
    event.target.value = "";
  };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDataChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const departments = [
    "Finance",
    "Sales",
    "Warehouse / Supply Chain",
    "Customer Fulfillment and Delivery",
    "Other",
  ];
  const ncSources = [
    "Delivery (Customer Complaint)",
    "Quality (Customer Complaint)",
    "Audit",
    "Incident Report",
  ];
  const warehouses = [
    "Bacolod",
    "Bohol",
    "Cavite Depot",
    "NCR",
    "Ormoc",
    "Starport Mindoro",
    "Tacloban",
    "Top Armada Mindoro",
    "Other",
  ];

  const handleSubmit = async (e) => {
    console.log("formDetails:", formDetails);
    console.log("formDetails?.id:", formDetails?.id);

    if (!formDetails?.id) {
      console.error("formDetails or formDetails.id is undefined");
      return;
    }

    const _formData = new FormData();

    _formData.append("issued_to", issuedTo);
    _formData.append("nc_source", ncSource);
    _formData.append("warehouse", warehouse);
    _formData.append("reference_number", referenceNumber);
    _formData.append("nc_description", ncDescription);

    // Upload images/files
    attachments.forEach((file) => {
      _formData.append("prospecting_images", file);
    });

    e.target.style.display = "none";

    if (loaderRef.current) {
      loaderRef.current.style.display = "inline-block";
    }

    try {
      const response = await ApiService.forms.submitCCARRequest(
        formDetails.id,
        _formData,
      );

      console.log("CCAR RESPONSE:", response);

      if (!response) {
        showSwal("No response received from server.");
        return;
      }

      const { success, ccar_request } = response;

      if (!success) {
        return showSwal(common.errors.SUBMIT_OFFSET_FORM_ERROR);
      }

      setReferenceId(ccar_request.reference_id);
      setDateAndTime(convertTo12HourPlusDateFormat(ccar_request.createdAt));
      setFormSubmitted(true);
    } catch (err) {
      console.error(err);
      showSwal("Failed to submit CCAR request.");
    } finally {
      e.target.style.display = "block";

      if (loaderRef.current) {
        loaderRef.current.style.display = "none";
      }

      setSubmitting(false);
    }
  };

  useEffect(() => {
    console.log("CCAR formDetails:", formDetails);

    if (formDetails) {
      console.log("CCAR ID:", formDetails.id);
    }
  }, [formDetails]);

  return (
    <div className="epr-form-container">
      <div className="epr-title">
        <h3>Customer Corrective Action Request Form</h3>
      </div>

      <div className="epr-form-panel">
        <div className="epr-form-body">
          <div className="epr-form-groupings">
            <div className="epr-form-group">
              <div className="epr-form-fields-prospecting">
                <label htmlFor="region">
                  Issued to<span className="epr-required">*</span>
                </label>
                <select
                  value={formData.issuedTo}
                  onChange={(e) => handleDataChange("issuedTo", e.target.value)}
                >
                  <option value="">Select Department</option>
                  {departments.map((department, index) => (
                    <option key={index} value={department}>
                      {department}
                    </option>
                  ))}
                </select>
              </div>
              <div className="epr-form-fields-prospecting">
                <label htmlFor="region">
                  NonConformity (NC) Source
                  <span className="epr-required">*</span>
                </label>
                <select
                  value={formData.ncSource}
                  onChange={(e) => handleDataChange("ncSource", e.target.value)}
                >
                  <option value="">Select Source</option>
                  {ncSources.map((source, index) => (
                    <option key={index} value={source}>
                      {source}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="epr-form-group">
              <div className="epr-form-fields-prospecting">
                <label htmlFor="region">
                  Warehouse<span className="epr-required">*</span>
                </label>
                <select
                  value={formData.warehouse}
                  onChange={(e) =>
                    handleDataChange("warehouse", e.target.value)
                  }
                >
                  <option value="">Select Warehouse</option>
                  {warehouses.map((warehouse, index) => (
                    <option key={index} value={warehouse}>
                      {warehouse}
                    </option>
                  ))}
                </select>
              </div>

              <div className="epr-form-fields-prospecting">
                <label htmlFor="">Customer / Audit Reference Number</label>
                <input
                  type="text"
                  value={formData.referenceNumber}
                  onChange={(e) =>
                    handleDataChange("referenceNumber", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="epr-form-group">
              <div className="epr-section-card">
                <div className="epr-title">
                  <h3>Pagtugon sa NC</h3>
                </div>
                <div className="epr-form-group">
                  <div className="epr-form-fields-prospecting">
                    <label htmlFor="">
                      A. Pagsalaysay sa Paltos (NC) na Delivery or Quality
                    </label>
                    <textarea
                      value={formData.ncDescription}
                      onChange={(e) =>
                        handleDataChange("ncDescription", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="epr-form-fields-prospecting">
                  <label>Attachments</label>

                  <input
                    id="ccar-upload"
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />

                  <button
                    type="button"
                    className="ccar-add-file-btn"
                    onClick={() =>
                      document.getElementById("ccar-upload").click()
                    }
                  >
                    <i className="fa fa-plus"></i> Add Attachment
                  </button>

                  {attachments.length > 0 && (
                    <div className="ccar-attachment-list">
                      {attachments.map((file, index) => (
                        <div key={index} className="ccar-attachment-item">
                          <div>
                            <i className="fa fa-paperclip"></i>
                            <span>{file.name}</span>
                          </div>

                          <button
                            type="button"
                            className="ccar-remove-btn"
                            onClick={() => removeAttachment(index)}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="epr-submit-action-btn">
            <button
              className="epr-submit-request"
              onClick={(e) => handleSubmit(e)}
            >
              <span className="epr-form-btn-txt">Submit Request</span>
              <img
                src={loader2}
                className="epr-form-loader"
                style={{ display: "none" }}
                ref={loaderRef}
              />
            </button>
          </div>
        </div>
      </div>
      <div />
    </div>
  );
}

export default CcarForm;
